module.exports = __webpack_public_path__ + "static/img/4.0eb119a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/4.jpg
// module id = JVBh
// module chunks = 0